<template>
  <div class="comment-container">
    <el-card class="time-stamp" shadow="hover">
      <div class="timeline-title">&nbsp;&nbsp;{{userInfo.user_name}} <span v-if="showTime">{{commentDate}}</span> </div>
      <div class="opinion-content">
        <el-input
          type="textarea"
          :rows="4"
          :placeholder="initPalaceholder"
          maxlength="100"
          show-word-limit
          @change="emitContent"
          v-model="opinionContent">
        </el-input>
      </div>
      <!-- 附件上传 -->
      <div class="upload-container">
        <WordUpload
          @showFileName="showFileNames"
          :fileMenuName="fileName"
          :plain="true"
          :id="taskNo"
          :refresh="false"
        />
        <div class="">
          <template v-for="(item, index) in files">
            <div class="file_wrapper" :key="index">
              <a
                class="file_button"
                target="_blank"
                :href="
                  isWord(item.fileUrl)
                    ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' +
                      item.fileUrl
                    : item.fileUrl"
                type="text"
                size="small"
              >
                {{ item.fileName }}
              </a>
              <div class="button-con">
                <i
                  style="margin-right: 5px;"
                  @click="downLoadFile(item.id)"
                  class="el-icon-download del_icon"
                ></i>
                <i
                  @click="delFile(item.id, index, 'file')"
                  class="el-icon-circle-close del_icon"
                ></i>
              </div>
            </div>
          </template>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { mapGetters } from "vuex";
import WordUpload from "@/components/wordUpload/wordUpload"
import { downLoadTemplate } from "@/router/downLoadTem"
import * as dictionaries from "@/api/zd/dictionaries"
import moment from "moment";
export default {
  name: "ZsCommentBlock",
  data() {
    return {
      files: [],
      opinionId: '',
      opinionContent: '',
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
    uploadHeaders() {
      return {
        "Blade-Auth": "bearer " + Cookies.get("saber-access-token"),
      };
    },
    commentDate() {
      return moment().format('YYYY-MM-DD') 
    }
  },
  props: {
    commitName: {
      type: String,
      default: 'SET_WORKFLOW_DATA'
    },
    initPalaceholder: {
      type: String,
      default: '请输入申报审核意见'
    },
    fileName: {
      type: String,
      default: '会签意见文件夹'
    },
    fileNum: {
      type: Number,
      default: 1
    },
    showTime: {
      type: Boolean,
      default: true
    },
    id: {
      type: String,
      default: ''
    },
    taskNo: {
      type: Number,
      default: 0
    },
    // 保存的数据
    taskSaveData: {
      type: Object,
      default: ()=> {
        return {
          comment: '',
          attachment: []
        }
      }
    }   
  },
  watch: {
    taskSaveData: {
      handler(val) {
        if(val.comment && val.comment != '') this.opinionContent = val.comment
        this.commitData()
      },
      immediate: true,
    },
  },
  components: {
    WordUpload
  },
  created() {
  },
  methods: {
    showFileNames(files) {
      this.files = files
      this.commitData()
    },

    handleSuccess(res, file, fileList) {
      if(res.code == 200){
        this.files = fileList;
        this.$emit('fileChange', this.files)
        this.commitData()
      }
    },

    downLoadFile(id) {
      downLoadTemplate("/api/file/down", {
        id,
      }).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },

       //删除附件
    delFile(fileId, index, name) {
      let self = this
      this.$confirm("确定将附件删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return dictionaries.deleteFile({
            fileId,
          });
        })
        .then(() => {

          this.files.splice(index, 1)
          this.commitData()
          // this.formData['files'].splice(index, 1);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        });
    },

    handlePreview(file) {

    },

    handleRemove(file, fileList) {
      this.files = fileList
      this.$emit('fileChange', this.files)
      this.commitData()
    },

    emitContent() {
      this.commitData()
    },

    commitData() {
      let attchmentList = []
      if(this.files.length > 0) {
        this.files.map(item => {
          attchmentList.push({
            id: item.id,
            fileName: item.fileName,
            name: item.fileName,
            fileUrl: item.fileUrl,
            url: this.isWord(item.fileUrl) ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' + item.fileUrl:item.fileUrl
          })
        })
      }
      this.$store.commit(this.commitName, {opinionContent: this.opinionContent, attchmentList: attchmentList})
    },

    handleExceed(files, fileList) {
      // this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
  }
}
</script>

<style lang="scss" scoped>
.comment-container{
  .time-stamp{
    .timeline-title{
      color: #666;
      font-size: 14px;
      margin-bottom: 8px;
      // padding-left: 10px;
      span{
        color: #999999;
      }
    }

    .opinion-content{
      .el-textarea{
        margin-bottom: 10px;
      }
    }
  }
  .file_wrapper{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    .file_button{
      color: #666;
      font-size: 12px;
    }
  }
  /deep/.el-timeline-item__node{
    background-color: #409EFF !important;
  }
}
</style>
